/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ArticleModel } from './ArticleModel';
import {
    ArticleModelFromJSON,
    ArticleModelFromJSONTyped,
    ArticleModelToJSON,
} from './ArticleModel';
import type { FileUrl } from './FileUrl';
import { FileUrlFromJSON, FileUrlFromJSONTyped, FileUrlToJSON } from './FileUrl';
import type { Html } from './Html';
import { HtmlFromJSON, HtmlFromJSONTyped, HtmlToJSON } from './Html';

/**
 *
 * @export
 * @interface ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet
 */
export interface ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet {
    /**
     *
     * @type {any}
     * @memberof ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet
     */
    id: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet
     */
    title: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet
     */
    content: any | null;
    /**
     *
     * @type {Html}
     * @memberof ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet
     */
    html: Html;
    /**
     *
     * @type {any}
     * @memberof ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet
     */
    type: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet
     */
    author: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet
     */
    publishOn: any | null;
    /**
     *
     * @type {FileUrl}
     * @memberof ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet
     */
    fileUrl?: FileUrl;
}

/**
 * Check if a given object implements the ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet interface.
 */
export function instanceOfResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet(
    value: object,
): boolean {
    if (!('id' in value)) return false;
    if (!('title' in value)) return false;
    if (!('content' in value)) return false;
    if (!('html' in value)) return false;
    if (!('type' in value)) return false;
    if (!('author' in value)) return false;
    if (!('publishOn' in value)) return false;
    return true;
}

export function ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGetFromJSON(
    json: any,
): ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet {
    return ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGetFromJSONTyped(json, false);
}

export function ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGetFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        content: json['content'],
        html: HtmlFromJSON(json['html']),
        type: json['type'],
        author: json['author'],
        publishOn: json['publish_on'],
        fileUrl: json['file_url'] == null ? undefined : FileUrlFromJSON(json['file_url']),
    };
}

export function ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGetToJSON(
    value?: ResponseGetFeaturedArticleApiV1ArticlesArticleFeaturedGet | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        title: value['title'],
        content: value['content'],
        html: HtmlToJSON(value['html']),
        type: value['type'],
        author: value['author'],
        publish_on: value['publishOn'],
        file_url: FileUrlToJSON(value['fileUrl']),
    };
}
